
export const formatPhoneNumberUS = (phoneNumberString) => {
    const match = phoneNumberString.replace(/\D/g, '').match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    return match ? [(match[1] ? '+1 ' : ''), '(', match[2], ') ', match[3], '-', match[4]].join('') : phoneNumberString
};
